import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thinking',
  templateUrl: './thinking.component.html',
  styleUrls: ['./thinking.component.css']
})
export class ThinkingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
